export const useBreadcrumb = () => {
    // Permet d'ajouter des liens dynamiques au fil d'Ariane dans le module des horaires
    function addBreadcrumbLinks(links) {
        const breadcrumbList = document.querySelector('.breadcrumb ul');
        if (breadcrumbList) {
            // Retirer les éléments dynamiques existants
            const existingDynamicItems = breadcrumbList.querySelectorAll('li.schedule-breadcrumb-item');
            existingDynamicItems.forEach((item) => item.remove());
            // Générer les nouveaux éléments
            links.forEach((link) => {
                let itemHTML;
                if (link.url === 'current-page') {
                    // Page courante
                    itemHTML = `<li class="breadcrumbs-item schedule-breadcrumb-item">${link.text}</li>`;
                } else {
                    // Liens vers les autres pages
                    itemHTML = `<li class="breadcrumbs-item schedule-breadcrumb-item">
                        <a href="${link.url}" class="breadcrumbs-link">${link.text}</a>
                    </li>`;
                }
                breadcrumbList.insertAdjacentHTML('beforeend', itemHTML);
            });
        }
    }
    return {
        addBreadcrumbLinks,
    };
};
